import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateRadiologyPrescriptionMutation as useChUpdateRadiologyPrescriptionMutationType } from "@/modules/patients/detail/meas-radiology-prescription/ch/services/__generated__/useChUpdateRadiologyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChUpdateRadiologyPrescriptionMutation($input: Ch_updateMeasRadiologyPrescriptionInput!) {
    ch_updateMeasRadiologyPrescription(input: $input) {
      ch_MeasRadiologyPrescription {
        id
        ...chMeasRadiologyPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateRadiologyPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateRadiologyPrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateRadiologyPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateRadiologyPrescriptionMutation }
